import React from 'react'
import { FormattedMessage } from 'react-intl'
import Skeleton from 'react-loading-skeleton'
import { Legend } from '../style'

export interface LegendItemProps {
  icon: React.ReactNode
  text: string
  loading: boolean
  width?: string
}

export const LegendItem: React.FC<LegendItemProps> = ({ icon, text, loading, width = '75px' }) => {
  return (
    <Legend>
      {loading ? (
        <>
          <Skeleton height="20px" width="20px" />
          <Skeleton height="12px" width={width} />
        </>
      ) : (
        <>
          {icon}
          <FormattedMessage id={text} defaultMessage={text} />
        </>
      )}
    </Legend>
  )
}

export default LegendItem
